/** Stable logical identities for this capability's owned fixed UDO templates. */
export enum StorefrontAuthenticationWorkspaceCapabilityUdoTemplateKey {
    loginCode = "73e3e102-70da-40d6-b774-564d98fffa80",
    authToken = "cb49b1f0-6c32-4635-9933-5a3e267af554",
}
